import React, { useState } from "react";

const FormCreateRevenue = () => {
  const [amount, setAmount] = useState(0);
  const [quarter, setQuarter] = useState("");

  const submitRevenueHandler = (e) => {
    e.preventDefault();
    console.log(amount, quarter);
  };

  return (
    <>
      <form onSubmit={submitRevenueHandler}>
        <div className="group-input">
          <label htmlFor="amount">Amount</label>
          <input
            type="number"
            className="rounded-lg"
            required={true}
            min={0}
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>
        <div className="group-input">
          <label htmlFor="kuartal">Kuartal</label>
          <input
            type="text"
            className="rounded-lg"
            required={true}
            value={quarter}
            onChange={(e) => setQuarter(e.target.value)}
          />
        </div>
        <div className="btn-group">
          <button
            type="submit"
            className="mx-auto border-2 p-2 w-[150px] rounded-lg btn-save bg-gray-50 hover:bg-white"
          >
            Submit
          </button>
        </div>
      </form>
    </>
  );
};

export default FormCreateRevenue;
